import {
  RelationshipListActionTypes,
  RELATIONSHIP_LIST_FAIL,
  RELATIONSHIP_LIST_LOADING,
  RELATIONSHIP_LIST_SUCCESS,
  RelationshipListState,
  RELATIONSHIP_LIST_API_MSG,
  RELATIONSHIP_LIST_API_RES,
} from "./ActionTypes";
import { RelationshipResponse } from "./Model";

const initialStateEditPosts: RelationshipListState = {
  loading: false,
  maritalStatusResponse: {} as RelationshipResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const relationshipListReducer = (
  state = initialStateEditPosts,
  action: RelationshipListActionTypes
): RelationshipListState => {
  switch (action.type) {
    case RELATIONSHIP_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case RELATIONSHIP_LIST_SUCCESS:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        successMsg: action.successMsg,
      };
    case RELATIONSHIP_LIST_FAIL:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case RELATIONSHIP_LIST_API_MSG:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case RELATIONSHIP_LIST_API_RES:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
